import React, { useState } from 'react';
import { createStripeBillingPortalSessionOperation } from '../../operations/user_profile_operations';
import {
  END_USER_PREFERENCES_ACCOUNT_INFORMATION_MOBILE_ROUTE,
  routeAbsoluteUrl,
} from '../../services/routes';
import { isEmbeddedInSmorgCompanion } from '../../services/smorg_companion_auth';
import { useGetCurrentSpaceMembershipQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const billingPortalReturnUrl = routeAbsoluteUrl(
  END_USER_PREFERENCES_ACCOUNT_INFORMATION_MOBILE_ROUTE,
);

const UserProfileManageSubscriptionButton = () => {
  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery();

  const [isBillingPortalLoading, setIsBillingPortalLoading] = useState(false);

  if (isEmbeddedInSmorgCompanion()) {
    /*
     * We are in the native app but this user signed up via Stripe in the web app.
     * In order to avoid a broken user journey, we direct the user to the web app.
     */
    return (
      <>
        <br />
        Manage your membership using the website you used to sign up
      </>
    );
  }

  const handleClickManageSubscription = async () => {
    setIsBillingPortalLoading(true);
    try {
      const session = await createStripeBillingPortalSessionOperation(
        currentSpaceMembership?.id,
        billingPortalReturnUrl,
      );
      console.log(JSON.stringify({ session }));
      if (session?.url) {
        window.location.href = session.url;
      }
    } finally {
      setIsBillingPortalLoading(false);
    }
  };

  return isBillingPortalLoading ? (
    'Please wait...'
  ) : (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        href="#"
        onClick={(ev) => {
          ev.preventDefault();
          handleClickManageSubscription();
        }}>
        Manage subscription
      </a>
    </>
  );
};

export default UserProfileManageSubscriptionButton;
